export default function Pagination({ page, total, limit, onChange }) {
  const pages = Math.max(1, Math.ceil(total / limit));
  const from = ((page - 1) * limit) + 1;
  const to = Math.min(page * limit, total);

  const btn = "px-4 py-2 rounded-lg text-sm font-semibold border border-[rgb(var(--border))] " +
    "transition-colors disabled:opacity-30 disabled:cursor-not-allowed " +
    "hover:border-[rgb(var(--primary))] hover:text-[rgb(var(--primary))]";

  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      <div className="text-sm opacity-40">
        Showing {from}–{to} of {total.toLocaleString()} records
      </div>
      <div className="flex items-center gap-2">
        <button className={btn} disabled={page <= 1} onClick={() => onChange(page - 1)}
          style={{ color: "rgb(var(--fg))", background: "transparent" }}>
          &larr; Prev
        </button>
        <span
          className="px-4 py-2 rounded-lg text-sm font-semibold text-white"
          style={{ background: "rgb(var(--primary))" }}
        >
          {page} / {pages}
        </span>
        <button className={btn} disabled={page >= pages} onClick={() => onChange(page + 1)}
          style={{ color: "rgb(var(--fg))", background: "transparent" }}>
          Next &rarr;
        </button>
      </div>
    </div>
  );
}